<template>
  <div class="detmech-accordion" v-if="detmechs.length !== 0">
    <div
      class="detmech-accordion__header member_details--bold detmech-accordion__trigger-wrapper"
      @click="toggleAccordion"
    >
      <div class="detmech-accordion__header-left typo-small">
        <strong>{{ title }}</strong>
      </div>
      <div v-if="hasTrigger" :class="triggerClasses">
        <DetmechAccordionArrowSVG />
      </div>
    </div>
    <div v-if="accordionIsOpen" class="detmech-accordion__container">
      <div
        v-for="detmech in detmechs"
        :key="detmech"
        class="detmech-accordion__row"
      >
        <div class="detmech-accordion__row-left typo-tiny">
          {{ $t(`deterioration_mechanisms.${detmech.name}.name`) }}
        </div>
        <div class="detmech-accordion__row-right typo-tiny">
          {{ detmech.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import DetmechAccordionArrowSVG from '@/images/detmech-accordion-arrow.svg';

const props = defineProps({
  title: { type: String, required: true },
  detmechs: { type: Array, required: true },
  isOpen: { type: Boolean, required: false },
  hasTrigger: { type: Boolean, required: false, default: true },
});

const accordionIsOpen = ref(null);

const triggerClasses = computed(() => ({
  'detmech-accordion__trigger': true,
  'detmech-accordion__trigger--active': accordionIsOpen.value,
}));

onMounted(() => {
  accordionIsOpen.value = props.isOpen;
});

function toggleAccordion() {
  if (props.hasTrigger) {
    accordionIsOpen.value = !accordionIsOpen.value;
  }
};
</script>

<style lang="scss" scoped>
@import '@/stylesheets/global';

.detmech-accordion {
  margin: bu(2) 0 0 0;
  border-top: 0.5px solid map-get($foreground-color, darker);
  padding-top: bu(2);

  &__trigger {
    align-items: center;
    display: flex;
    justify-content: center;

    &--active {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: bu(1);
  }

  &__row {
    color: map-get($foreground-color, dark);
    display: flex;
    justify-content: space-between;

    &:not(:last-child) {
      margin-bottom: bu(1);
    }
  }
}
</style>
